/**
 * Links between the Connect wizard and the gateway page, in one place so both
 * sides agree on the query parameters.
 */

/** The gateway page with this gateway's sheet open (on a tab: overview, devices, protocols, settings). */
export function gatewayHref(gatewayId: string, tab?: string): string {
  const q = new URLSearchParams({ gateway: gatewayId });
  if (tab) q.set("tab", tab);
  return `/app/gateways?${q.toString()}`;
}

/** The gateway's Devices tab (where a device lands after Go live). */
export function gatewayDevicesHref(gatewayId: string): string {
  return gatewayHref(gatewayId, "devices");
}

/** The Connect wizard with this gateway pre-selected. */
export function connectToGatewayHref(gatewayId: string): string {
  return `/app/connect?${new URLSearchParams({ gateway: gatewayId }).toString()}`;
}
